import React from 'react';
import './BenefitsSection.css';

function BenefitsSection() {
    const articles = [
        {
            title: 'По-силно хващане и по-голяма тежест',
            content: 'Гриповете прехвърлят част от напрежението от предмишците върху по-силните мускули на гърба и ръцете. Така можете да вдигате по-тежко при мъртва тяга, лицеви опори и редове, без хващането да ви ограничава.',
            icon: '1'
        },
        {
            title: 'По-малко умора на предмишците',
            content: 'При упражнения за дърпане предмишците често се уморяват по-бързо от целевите мускулни групи. С грипове можете да завършите повече повторения и серии, като насочите усилията към гръб и бицепси.',
            icon: '2'
        },
        {
            title: 'По-добра силова прогресия',
            content: 'Когато хващането не ви ограничава, можете да увеличивате тежестите постепенно и да подобрявате силовата си. Това е особено полезно при мъртва тяга и други основни упражнения.',
            icon: '3'
        },
        {
            title: 'Подобрена сигурност при тренировка',
            content: 'Антихлъзгащата повърхност на гриповете намалява риска от изплъзване на щангата или лостовете. Можете да се концентрирате върху техниката, без да се притеснявате за хващането.',
            icon: '4'
        },
        {
            title: 'Подходящи за всички нива',
            content: 'Гриповете са полезни както за начинаещи, които все още укрепват хващането, така и за напреднали, които вдигат тежки тежести. Унисекс дизайн и регулируемо прилягане.',
            icon: '5'
        },
        {
            title: 'Защита на китките',
            content: 'Поддръжката за китки помага да запазите неутрална позиция на китката по време на упражнения и намалява напрежението върху ставите при тежки дърпания.',
            icon: '6'
        }
    ];

    return (
        <section className="benefits-section" id="benefits">
            <h2>Защо да използвате грипове за вдигане?</h2>
            <p className="benefits-intro">Професионалните lifting straps са есенциална екипировка за всеки, който сериозно тренира с тежести. Ето какво печелите:</p>
            <div className="benefits-grid">
                {articles.map((article, index) => (
                    <article key={index} className="benefit-card">
                        <div className="benefit-icon">{article.icon}</div>
                        <h3>{article.title}</h3>
                        <p>{article.content}</p>
                    </article>
                ))}
            </div>
        </section>
    );
}

export default BenefitsSection;
